<template>
  <v-layout row wrap justify-center pa-0 ma-0>
    <v-flex sm12 md10 lg6 xl5 pt-0 mt-0>
      <div class="text-xs-center mt-2">
        <v-img max-height="250px" contain :src="this.teamData.banner" v-if="this.teamData.banner" />  
      </div>
      <v-card-title>
        <v-btn :href='"https://twitch.tv/team/" + this.teamData.name' text>
          <v-icon size="35px">fab fa-twitch</v-icon>
        </v-btn>
        <v-spacer />
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details clearable />
      </v-card-title>
      <v-data-table :headers="computedHeaders" :items="orderedUsers" :loading="!isLoaded" :sort-by.sync="sortBy" :sort-desc.sync="sortDescending" :footer-props="{itemsPerPageOptions:[100,200,-1]}" :search="search" class="elevation-1">
        <v-progress-linear v-slot:progress color="purple" indeterminate></v-progress-linear>

        <template v-slot:item.banner="{ item }">
            <a :href="item.url">
              <v-img width="12vw" contain v-if="item.video_banner" :src="item.video_banner" />
              <v-img width="12vw" v-if="!item.video_banner && item.profile_banner" :src="item.profile_banner" />
            </a>
        </template>

        <template v-slot:item.name="{ item }">
          <twitch-channel-link :channel='item' :live='item.stream' />
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import TwitchChannelLink from '@/components/TwitchChannelLink'
import TwitchWrapper from '@/TwitchWrapper'
import sort from 'fast-sort'

export default {
  name: 'TwitchTeam',
  components: {
    TwitchChannelLink
  },
  props: {
    team: String,
  },
  data () {
    return {
      isLoaded: false,
      error: null,
      teamData: {},
      channels: [],
      twitch: new TwitchWrapper(this.$root.$data.clientId),
      search:'',

      sortBy: '',
      sortDescending: true,
      compare: this.$router.currentRoute.query.compare,
      headers: [
        { text: 'Banner', align: 'left', sortable: false, value: 'banner' },
        { text: 'Name', value: 'name', align: 'left', },
        { text: 'Followers', value: 'followers', align: 'center'},
      ],
    }
  },
  computed: {
    computedHeaders: function () {
      var h = this.headers
      if(this.compareFollowed){ h.push({ text: 'Followed', value: 'isFollowed', align: 'center'}) }
      return h
    },
    orderedUsers: function () {
      return sort(this.teamData.users).by([
        {desc: 'isLive'},
        {desc: 'followers'},
      ])
    },
    backgroundStyle: function () {
      return `background-image: url('${this.teamData.background}');
        background-size: contain;
        background-repeat: repeat-y;
      `
    },
    compareFollowed: function() {
      if(this.$router.currentRoute.query.compareFollowed == 1){
        return true
      }
      return false
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    'team': 'fetchData'
  },
  methods: {
    fetchData () {
      this.isLoaded = false

      if(this.compareFollowed) {
        this.twitch.GetFollowedChannelsCached(this.$root.$data.userId).then(c => {
            this.channels = c
            this.GetUnfollowed()
        }).catch(this.errorHandle)
      }

      this.twitch.GetTeam(this.team).then(team => {

          // Fix data binding
          team.users.forEach(u => {
            u.stream = false
            u.isLive = false
          });

          this.teamData = team

          // Update Live Channels
          let channelIds = team.users.map(t => t._id)        
          this.twitch.GetStreams(channelIds).then(streams => {
            streams.forEach(e => {
              var i = team.users.find(u => u._id === e.channel._id.toString())
              i.stream = e
              i.isLive = true
            });

            if(this.compare == '1'){
              if(this.headers.length < 4){
                this.headers.push({ text: 'Followed', value: 'isFollowed', align: 'center'})
              }

              team.users.forEach(u => {
                u.isFollowed = 'No'
              })

              this.twitch.GetFollowedChannelsCached(this.$root.$data.userId).then(channels => {
                this.channels = channels
                team.users.forEach(u => {
                  var i = channels.find(c => c._id.toString() === u._id)
                  if(i){ 
                    u.isFollowed = 'Yes'
                  }
                })
                this.isLoaded = false
                this.isLoaded = true
              })
            }

            this.isLoaded = true
            this.teamData = team
            if(this.compareFollowed) {
              this.GetUnfollowed()
            }
          })
      }).catch(this.errorHandle)
    },
    GetUnfollowed () {
      if(this.teamData.users != undefined && this.channels.length > 0)
      {
        this.teamData.users.forEach(c => {
          var i = this.channels.find(u => u._id === c._id.toString())
          if(i) {
            c.isFollowed = true
          }
          else {
           c.isFollowed = false 
          }
        })

        let users = this.teamData.users.filter(u => u.isFollowed == false)
        this.teamData.users = users
      }
    },
    errorHandle(e) {
      try { this.$emit('errorUpdate', JSON.parse(e.message).message) }
      catch {this.$emit('errorUpdate', e) }
    }
  }
}
</script>

<style>

  .followed {
      background: #008000;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      margin-left: 4px;
      margin-right: 4px;
      display: inline-block;

  }

</style>
